import {useFilterLoading, useSourceFilter} from 'filters/contexts/FilterStackProvider';
import {useCountPoliciesQuery} from 'features/GlobalFilterProvider/api/countPolicies.generated';
import {clearFilter} from 'filters/utils';
import {PageFilter} from 'filters';

import {NothingFound} from 'modules/decisionsNext/components/BaseFilter/TopBar/components/NothingFound';

export const useGlobalFilterTopbarEndAdornment = () => {
  const filter = useSourceFilter();

  const {data, loading} = useCountPoliciesQuery({
    variables: {
      filter: clearFilter(filter || ({} as PageFilter)),
    },
    skip: useFilterLoading(),
  });

  if (loading || data?.aggregatePolicy.metric) {
    return null;
  }

  return <NothingFound />;
};
